module.exports = __webpack_public_path__ + "media/images/icons/icon_email-2f446ae50f5bdbda2aac69ab0424669b.svg";